let ResizeObserver;
// Avoid crashing in environments where ResizeObserver is not supported
if (typeof self !== 'undefined' && self.ResizeObserver) {
    ResizeObserver = self.ResizeObserver;
}
else {
    // Define a minimal type for ResizeObserver polyfill
    class ResizeObserverPolyfill {
        constructor(callback) {
            this.callback = callback;
        }
        observe(_target, _options) {
            this.callback();
        }
        unobserve(_target) {
            // Do nothing
        }
        disconnect() {
            // Do nothing
        }
    }
    ResizeObserver = ResizeObserverPolyfill;
}
export { ResizeObserver };
//# sourceMappingURL=resizeObserver.js.map